import { loadImages } from "../utils/importImages";

const maternityImages = loadImages(
  require.context("./Images", false, /Mat\d+\.webp$/)
);

function Maternity() {
  return (
    <div id="scroll-container" className="scroll-container">
      <h2>Maternity Shoot</h2>
      {maternityImages.map((src, index) => (
        <img key={index} src={src} alt={`Maternity ${index + 1}`} loading="lazy" />
      ))}
    </div>
  );
}

export default Maternity;
